import './Paywall.scss';

import React from 'react';
import { connect } from 'react-redux';

import { TIER_NAMES } from 'features/biller/constants';
import { planPricing } from 'features/biller/util';
import GoToManagePlanPageButton from 'features/managePlan/components/GoToManagePlanPageButton';
import { selectAllProducts } from 'features/managePlan/selectors';

import Box from 'components/Box';
import Text from 'components/Text';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';

const { cxEl } = cxHelpers('Paywall');

const Paywall = ({ products }) => {
  const monthlyEssentialPlanPrice = planPricing(
    products,
    TIER_NAMES.ESSENTIALS
  );

  return (
    <Box>
      <Box w={360} h={212}>
        <img
          src={require('features/messengerv2/TeamEmailsView/Paywall/AnnouncementsBG@2x.png')}
        />
      </Box>
      <Box p={32}>
        <Box tcenter mb={24}>
          <Text fs18 fw600 i18n="team_announcements.paywall.headline" navy />
        </Box>
        <Box tcenter mb={16}>
          <Text fs14 i18n="team_announcements.paywall.subheading" />
        </Box>
        <Box>
          <ul className="list-bulleted">
            {toI18n('team_announcements.paywall.features').map((feature, i) => (
              <li key={i} className={cxEl('listItem')}>
                <Text fs14>{feature}</Text>
              </li>
            ))}
          </ul>
        </Box>
        <Box mb12>
          <GoToManagePlanPageButton
            fullWidth
            loadFullPage
            theme="primary"
            i18n="team_announcements.paywall.button"
          />
        </Box>
        <Box tcenter>
          {monthlyEssentialPlanPrice && (
            <Text
              i18n="team_announcements.paywall.fine_print"
              fs10
              i18nProps={{ price: monthlyEssentialPlanPrice }}
              navy
              lh={1.6}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default connect(
  state => ({ products: selectAllProducts(state) }),
  {}
)(Paywall);
